export default "__VITE_ASSET__CtEYqpC___"